module.exports = __webpack_public_path__ + "static/media/visaShop.b83e6703.png";